<div>
  <img class="signature" *ngIf="HasImage" [src]="signature?.signature?.imageSignature" alt="Signature"> <br>
  Electronically signed by: {{signature?.signature?.userName}} <br> {{SignatureDate}}
</div>
